import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassSelectionMasterReadSlice = createSlice({
  name: "ClassSelectionMasterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassSelectionMasterRead: (state) => {
      state.isLoading = true;
    },
    successClassSelectionMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassSelectionMasterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassSelectionMasterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassSelectionMasterRead,
  failureClassSelectionMasterRead,
  successClassSelectionMasterRead,
  clearClassSelectionMasterRead,
} = ClassSelectionMasterReadSlice.actions;

export default ClassSelectionMasterReadSlice.reducer;
